import { withInstall } from '../utils/type';
import AnchorBox from './anchor-box';
import AnchorPlugin from './anchor-plugin';
export default withInstall(AnchorBox, AnchorPlugin);